import { useState } from "react";
import { Box } from "@mui/material";
import { MenuItems } from "dashboard/configs";
import { useLocation } from "react-router-dom";
import DrawerLayout from "./DrawerLayout";
import HeaderLayout from "./HeaderLayout";
import { CustomDrawerHeader } from "./custom";
import { green } from "@mui/material/colors";

const PanelLayout = (props) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const handleDrawerOpen = () => setIsDrawerOpen(true);
  const handleDrawerClose = () => setIsDrawerOpen(false);
  const location = useLocation();
  const currentPageTitle = MenuItems.find(
    (item) => item.route === location.pathname
  )?.title;

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <HeaderLayout
          handleDrawerOpen={handleDrawerOpen}
          isDrawerOpen={isDrawerOpen}
        />
        <DrawerLayout
          isDrawerOpen={isDrawerOpen}
          handleDrawerClose={handleDrawerClose}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            minHeight: "100vh",
            backgroundColor: "#afafaf17",
          }}
        >
          <CustomDrawerHeader />
          {props.children}
        </Box>
      </Box>
    </>
  );
};

export default PanelLayout;
